export default __webpack_public_path__ + "static/media/emotion-l@3x.34d3f997.png";